<template>
  <div>
    <p class="text-text text-md font-bold my-12">{{ $t('successText') }}</p>
    <BaseButton size="sm" theme="red" @click="$emit('finish')">{{ $t('finishLabel') }}</BaseButton>
  </div>
</template>

<script>
import BaseButton from "@/components/UI/BaseButton";

export default {
  name: "ImportPortfolioStep3",
  components: {BaseButton},
  i18n: {
    messages: {
      en: {
        successText: 'Report import has successfully finished!',
        finishLabel: 'Excellent'
      },
      ru: {
        successText: 'Импорт данных успешно завершён!',
        finishLabel: 'Отлично'
      }
    }
  }
}
</script>

<style scoped>

</style>